import { render, staticRenderFns } from "./ArbitragePtaProcess.vue?vue&type=template&id=1ca474fa"
import script from "./ArbitragePtaProcess.vue?vue&type=script&lang=js"
export * from "./ArbitragePtaProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports